const t = {
  NoOptions: "Aucun résultat",
};

module.exports = {
  t,
};
